import React, { FunctionComponent, useState } from 'react';
import { AdminOrganizationDetails } from 'api';
import { FiltersWrapper } from 'ui/molecules/filtering';
import Translate from 'src/ui/atoms/translate';
import Header from 'src/ui/atoms/header';
import Section from 'src/ui/atoms/section';
import WideContent from 'src/core/layout/content/wide-content';
import { currentUserHasManageUsersAndGroupsPermission } from 'src/apps/issuer/helpers/userPermissions';
import { currentOrganizationHasManageUsersAndGroupsPermission } from 'src/apps/issuer/helpers/organizationPermissions';
import { useCurrentUserSelector } from 'src/core/auth/hooks';
import GroupsTableWrapper from '../../../shared/groups-table';
import PageWrapper from 'src/core/layout/content/page-wrapper';

interface OrganizationGroupsTableProps {
  organization: AdminOrganizationDetails;
  forceDataLoad?: boolean;
  defaultLimit?: number;
  goToDetails?: (groupId: string) => void;
}

const OrganizationGroupsTable: FunctionComponent<OrganizationGroupsTableProps> = ({ organization, ...restProps }) => {
  const { currentUser } = useCurrentUserSelector();
  const [filterPopupHeight, setFilterPopupHeight] = useState(0);

  const hasPermission =
    currentUserHasManageUsersAndGroupsPermission(currentUser?.permissions || []) ||
    currentOrganizationHasManageUsersAndGroupsPermission(organization);

  return (
    <PageWrapper paddingBottom={filterPopupHeight}>
      <Section>
        <WideContent>
          <Header size="small">
            <Translate name="issuerOrganizationsDetails.groupsTable.title" />
          </Header>
          <GroupsTableWrapper
            hasPermission={hasPermission}
            organizationId={organization.id}
            showOrganizationColumn={false}
            setFilterPopupHeight={setFilterPopupHeight}
            skipFilterUrlSync={true}
            {...restProps}
          />
        </WideContent>
      </Section>
    </PageWrapper>
  );
};

export default OrganizationGroupsTable;
